export enum SocketChannel {
	FRONT_CHANNEL = 'FrontChannel',
	NOTIFY_CHANNEL = 'NotifyChannel',
	RBIDOS_REQUEST_CHANNEL = 'RbidosRequestChannel',
	BG_REQUEST_CHANNEL = 'BgRequestChannel',
	BG_LIMIT_REQUEST_CHANNEL = 'BgLimitRequestChannel',
	CUSTOMER_IDENTIFICATION_CHANNEL = 'CustomerIdentificationChannel',
	LEAD_CHANNEL = 'LeadChannel',
	RESERVE_ACCOUNT_CHANNEL = 'ReserveAccountChannel',
	PARTNER_CONTRACT_CHANNEL = 'PartnerContractChannel',
	REPORT_STATE_CHANNEL = 'ReportStateChannel',
	ORD_CHANNEL = 'OrdChannel',
	PING_CHANNEL = 'PingChannel',
}
